const app = {
    state:{
        departmentCache:false,
    },
    mutations:{
        setDepartmentCache:function(state,v){
            state.departmentCache = v;
        },
    },
    actions:{
        setDepartmentCacheFun:function(context,v){
            context.commit('setDepartmentCache',v)
        },
    },
}
export default app


// WEBPACK FOOTER //
// ./src/store/modules/nCacheApp.js